export default __webpack_public_path__ + "static/media/play-button.df3e12df.svg";